import {
  ButtonContainer,
  Container,
  Form,
  FormTitle,
  Section,
  LoadingText,
} from "./styles";
import Input from "../../components/Input";
import UiButton from "../../components/ui/Button";
import { useState } from "react";
import CategorySelector from "./components/CategorySelector";
import useGetLocation from "../../hooks/useGetLocation";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { registerStore } from "../../services/storeRegistrationService";

export default function New() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    contact: "",
    category: "",
  });
  const { coords } = useGetLocation();

  async function onSubmit() {
    try {
      await registerStore({
        name: formValues.name,
        description: formValues.description,
        contact: formValues.contact,
        category: formValues.category,
        // Uses the real coords from useGetLocation() -- the original code sent
        // formValues.coords instead, a separate useState field that was
        // initialized to [0, 0] and never actually updated from the real
        // location, so every registration silently recorded 0,0.
        latitude: coords ? coords[0] : 0,
        longitude: coords ? coords[1] : 0,
      });
      toast("Estabelecimento gravado com sucesso!", {
        type: "success",
        autoClose: 2000,
        onClose: () => navigate("/"),
      });
    } catch (error) {
      console.log(error);
      toast("Não foi possível gravar o estabelecimento. Tente novamente.", {
        type: "error",
        autoClose: 2000,
      });
    }
  }

  if (!coords) {
    return <LoadingText>Obtendo localização ...</LoadingText>;
  }

  return (
    <Container>
      <Form
        onSubmit={(ev) => {
          ev.preventDefault();
          onSubmit();
        }}
      >
        <FormTitle>Cadastro do comércio local</FormTitle>

        <Section>Dados</Section>

        <Input
          label="Nome do local"
          name="name"
          value={formValues.name}
          onChange={setFormValues}
        />

        <Input
          label="Descrição"
          name="description"
          value={formValues.description}
          onChange={setFormValues}
        />

        <Input
          label="Contato"
          name="contact"
          value={formValues.contact}
          onChange={setFormValues}
        />

        <Section>Categoria</Section>

        <CategorySelector
          selectedCategory={formValues.category}
          onSelect={(category) => {
            setFormValues((prev) => ({ ...prev, category }));
          }}
        />

        <ButtonContainer>
          <UiButton type="submit" full>
            Salvar
          </UiButton>
        </ButtonContainer>
      </Form>
    </Container>
  );
}
